import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth/auth.service';
import { LoginViewModel } from '../models/login-view-model';
import { ContactView } from '../models/ContactView';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ContactService {

  myHeader: Headers;
  countryData: any;
  countryList:any;
  states:any;

  constructor(private http: Http,
    private authHttp: AuthHttp,
    public auth: AuthService) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('contact Service Initialized...');
  }

  getContacts(contractNumber: string) {
    return this.authHttp.get(`/api/Contact/GetAllContacts?psContractNumber=` + contractNumber,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getContacts request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }


  getJSSIContacts(contractNumber: string) {
    return this.authHttp.get(`/api/Contact/GetJSSITeamContacts?psContractNumber=` + contractNumber,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getJSSIContacts request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  getStateList(country: string) {
    return this.authHttp.get(`/api/Contact/StateList?psCountry=` + country,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getStateList request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }
  // getOtherStateList(country:string):any{
  //   this.http.get('../../assets/data/CountriesStates.JSON').subscribe(response => {
  //     this.countryData = response.json();
  //     console.log('state'+this.countryData);
  //     this.countryList = Object.keys(this.countryData);
  //     this.states =this.countryData[country];
  //     return  this.states;
  // });
  // }

  getContact(accountID: string, contactID: string, role: string, contractNumber: string) {
    return this.authHttp.get(`/api/Contact/GetContactByRole`,
      {
        headers: this.myHeader,
        search: {
          'psAccountID': accountID,
          'psContactID': contactID,
          'psRole': role,
          'psContractNumber': contractNumber
        }
      }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getContact request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  updateContactByRole(contactView: ContactView) {
    return this.authHttp.post(`/api/Contact/UpdateContactByRole`, contactView, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Update Contact By Role has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getContactByTransactionID(userID: string, transactionID: string) {
    return this.authHttp.get(`/api/Contact/GetContactByTransactionID`,
      {
        headers: this.myHeader,
        search: {
          'psUserID': userID,
          'psTransactionID': transactionID
        }
      }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getContactByTransactionID request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/contact.service.ts